(function () {
    "use strict";

    angular.module('angular.emlpayments')
        .factory('navigate', ['$timeout', '$location', '$route', function ($timeout, $location, $route) {

            var referrerInternal,
                defaultUrl = "/";

            return {
                to: to,
                setReferrer: setReferrer,
                setDefaultUrl: setDefaultUrl,
                toReferrerOrDefault: toReferrerOrDefault
            };


            function to(url) {
                $timeout(function () { 
                    if ($location.path() === url) {                        
                        $route.reload();
                    }
                    $location.path(url);                                        
                });
            }

            function toReferrerOrDefault() {
                if (referrerInternal) {
                    to(referrerInternal);
                }
                else {
                    to(defaultUrl);
                }
            }

            function setReferrer(referrer) {
                referrerInternal = referrer;
            }

            function setDefaultUrl(url) {
                defaultUrl = url;
            }
        }]);
}());